const MOMENTS = [
 ["The 8 a.m. class","i-cup",[
  ["funny","Nobody in this family has ever been a morning person. You come by it honestly, and my only advice is <em>&#8230;</em>"],
  ["funny","For the record, I avoided an 8 a.m. class my entire life. You're braver than <em>&#8230;</em>"],
  ["funny","Whoever schedules a class at 8 a.m. has clearly never met a 19-year-old. Since we can't fight it, we <em>&#8230;</em>"],
  ["funny","There is no shame in being the one who walks in carrying a coffee the size of <em>&#8230;</em>"],
  ["short","Coffee's on me today."],
  ["short","Go. You'll be glad you did."],
  ["short","First one's on me."],
  ["short","You've done harder things than this."],
  ["heart","I was the one waking you up for 18 years. You've got it from here, and I'm <em>&#8230;</em>"],
  ["heart","Getting up when you don't want to is most of what being an adult is. You already <em>&#8230;</em>"],
  ["heart","You have never once been late to anything that actually mattered to you, and that tells me <em>&#8230;</em>"],
  ["heart","Some mornings you just get up and go. You learned that from watching <em>&#8230;</em>"]]],
 ["When the dining hall loses","i-bowl",[
  ["funny","I refuse to believe anyone has ever walked out of a dining hall and said the food was great. Go find something with <em>&#8230;</em>"],
  ["funny","Somewhere in that town there is a genuinely good meal. Find it and report back, because <em>&#8230;</em>"],
  ["funny","Every dining hall in America is running the same 3 recipes and not one of them is <em>&#8230;</em>"],
  ["funny","You refused to eat anything green until you were about 11, so my expectations are low and <em>&#8230;</em>"],
  ["short","Eat something that isn't beige."],
  ["short","Real food. On me."],
  ["short","Go get something hot."],
  ["short","Order what you actually want."],
  ["heart","You need feeding and I can't do it from here, so this is me doing it the only way <em>&#8230;</em>"],
  ["heart","It's a small thing, but I hate the thought of you eating badly. Have something you actually <em>&#8230;</em>"],
  ["heart","Sit down and eat it properly, at a table, like a person. That's all I <em>&#8230;</em>"],
  ["heart","Take somebody with you. Half of a good meal is <em>&#8230;</em>"]]],
 ["Two in the morning","i-moon",[
  ["funny","I'm not asking what you're doing awake. I'm only saying that whatever it is, you shouldn't do it <em>&#8230;</em>"],
  ["funny","Nothing good is ever decided at 2 a.m. except what to order. Choose <em>&#8230;</em>"],
  ["funny","Everything is funnier at 2 a.m. and none of it will be tomorrow. Enjoy it while <em>&#8230;</em>"],
  ["funny","I don't need a report on this one. Just don't be the one who <em>&#8230;</em>"],
  ["short","Don't do it hungry."],
  ["short","Feed whoever's up with you."],
  ["short","Order it. Then go to bed."],
  ["short","This one's for the late night."],
  ["heart","There was a time 2 a.m. meant you had a fever and I was in the chair. It's different now, and <em>&#8230;</em>"],
  ["heart","Whatever you're up finishing, I hope it's going well, and I hope somebody's <em>&#8230;</em>"],
  ["heart","The best conversations of my life happened after midnight in a kitchen with people I <em>&#8230;</em>"],
  ["heart","One day you'll miss being up this late for no good reason, so <em>&#8230;</em>"]]],
 ["Out of everything","i-cart",[
  ["funny","There is no fairy who restocks the toilet paper. I checked. It was me for 18 years, and now <em>&#8230;</em>"],
  ["funny","Welcome to the part of adulthood nobody advertises, where paper towels cost real money and <em>&#8230;</em>"],
  ["funny","The first time you run out of everything at once is a rite of passage. Congratulations, and <em>&#8230;</em>"],
  ["funny","Buy the good paper towels. Life is short and the cheap ones <em>&#8230;</em>"],
  ["short","Go get the boring things."],
  ["short","The unglamorous page. Use it."],
  ["short","Restock. Dull but necessary."],
  ["short","Target run, on me."],
  ["heart","You never once had to wonder whether we had what we needed, and I'm glad. Now it's your turn, and <em>&#8230;</em>"],
  ["heart","This is the least romantic page in the book and probably the most useful, which is also true of <em>&#8230;</em>"],
  ["heart","Handling the dull things is most of taking care of yourself, and you're better at it than <em>&#8230;</em>"],
  ["heart","I like knowing you've got what you need in there. Even the unglamorous things. Especially <em>&#8230;</em>"]]],
 ["The all-nighter","i-bolt",[
  ["funny","Studying is 10 percent studying and 90 percent snacks. I don't make the rules. Here's <em>&#8230;</em>"],
  ["funny","I have never once seen you fail at something you actually sat down for. So <em>&#8230;</em>"],
  ["funny","Nobody has ever done their best work at 4 a.m., but everybody has to find that out <em>&#8230;</em>"],
  ["funny","Sleep isn't optional, it's only delayed. Use this for the delay, and then <em>&#8230;</em>"],
  ["short","You know this. Go show them."],
  ["short","Eat first. Then panic."],
  ["short","Fuel up. You've got this."],
  ["short","One week. Then it's over."],
  ["heart","You do this thing where you decide you're going to be ready, and then you are. I've watched it since <em>&#8230;</em>"],
  ["heart","Whatever the grade turns out to be, it does not change one single thing about <em>&#8230;</em>"],
  ["heart","You have never needed me to tell you to work hard. If anything I'd rather you <em>&#8230;</em>"],
  ["heart","However this week goes, it's one week out of 4 years. Keep it <em>&#8230;</em>"]]],
 ["Nothing to wear","i-hang",[
  ["funny","You have clothes. I packed them. But I also remember being your age with a full closet and nothing to wear, so <em>&#8230;</em>"],
  ["funny","Buy the thing you'll actually wear, not the thing you'll wear once and <em>&#8230;</em>"],
  ["funny","Half of what I packed you'll never touch. The other half you'll wear until <em>&#8230;</em>"],
  ["funny","There's an outfit out there that makes you feel unstoppable. Go find it and don't <em>&#8230;</em>"],
  ["short","Get something you feel good in."],
  ["short","Treat yourself. Within reason."],
  ["short","Something new. Why not."],
  ["short","You'll know it when you see it."],
  ["heart","I want you walking in somewhere feeling like yourself. That's all this is <em>&#8230;</em>"],
  ["heart","There's a version of you that walks into a room like you belong there. Spend this on <em>&#8230;</em>"],
  ["heart","You've always dressed like yourself and never like everybody else. I hope college doesn't <em>&#8230;</em>"],
  ["heart","Buy one thing that's properly good rather than 3 things that <em>&#8230;</em>"]]],
 ["Getting there","i-car",[
  ["funny","Walking builds character. So does not walking, at midnight, in the rain. Use <em>&#8230;</em>"],
  ["funny","If it's dark, or far, or something feels off, take the ride. That's the entire reason <em>&#8230;</em>"],
  ["funny","Your legs are excellent and I still don't want you using them at 1 a.m. in <em>&#8230;</em>"],
  ["funny","The bus exists. The ride exists. Standing in the rain arguing with yourself does not <em>&#8230;</em>"],
  ["short","Don't walk it. Take the ride."],
  ["short","Get home safe."],
  ["short","Split it with a friend."],
  ["short","Just get in the car."],
  ["heart","The only thing I'll ever ask is that you never talk yourself into walking when something feels wrong. Just <em>&#8230;</em>"],
  ["heart","I sleep better knowing you have a way home. Please <em>&#8230;</em>"],
  ["heart","There is no amount I wouldn't spend on you getting back in one piece. So <em>&#8230;</em>"],
  ["heart","Text me when you're in. Not because I'm checking, but because <em>&#8230;</em>"]]],
 ["When the charger dies","i-plug",[
  ["funny","Your charger has been held together by hope since March. Replace it before <em>&#8230;</em>"],
  ["funny","I'd like to be able to reach you, which requires your phone to be alive, which requires <em>&#8230;</em>"],
  ["funny","Buy 2. You will lose one inside a month and we both <em>&#8230;</em>"],
  ["funny","A dead phone is only ever a problem for the person trying to reach you, which is <em>&#8230;</em>"],
  ["short","Fix the cable."],
  ["short","Stay reachable."],
  ["short","Buy the spare."],
  ["short","Keep it charged."],
  ["heart","I'm not going to pretend this page isn't partly for me. I like being able to <em>&#8230;</em>"],
  ["heart","Answer sometimes. Even if it's only to say you're <em>&#8230;</em>"],
  ["heart","You don't have to call every day. Just don't go quiet when something's <em>&#8230;</em>"],
  ["heart","The days you don't feel like talking are the days I most want to <em>&#8230;</em>"]]],
 ["Laundry day","i-wash",[
  ["funny","Whites, colors, and I'll deal with it later. Only 2 of those are real. Here's the quarters for <em>&#8230;</em>"],
  ["funny","The day you run out of clean everything is coming for you. This is for <em>&#8230;</em>"],
  ["funny","Cold water, and keep the red thing away from the white things. That's the whole lesson and it took me <em>&#8230;</em>"],
  ["funny","The machine will eat your quarters. It's a tax. Pay it and <em>&#8230;</em>"],
  ["short","Wash the sheets too."],
  ["short","You'll know when."],
  ["short","Quarters. Go."],
  ["short","Everything you own, at once."],
  ["heart","I did this for you for 18 years without once thinking about it. It's a small thing to miss, and <em>&#8230;</em>"],
  ["heart","There is something about clean sheets at the end of a long week. Give yourself <em>&#8230;</em>"],
  ["heart","Clean clothes on a bad week do more for a person than they have any right to, which is why <em>&#8230;</em>"],
  ["heart","I used to fold your things and think about you wearing them somewhere I couldn't see. Now <em>&#8230;</em>"]]],
 ["Permission to do nothing","i-pop",[
  ["funny","Consider this a doctor's note. You are excused from being impressive for <em>&#8230;</em>"],
  ["funny","Do something completely useless, on purpose. That's the assignment and <em>&#8230;</em>"],
  ["funny","Cancel something. Anything. You'll feel better within <em>&#8230;</em>"],
  ["funny","This page is for the night you should be studying and are absolutely not going to <em>&#8230;</em>"],
  ["short","Take the night off."],
  ["short","Go be 18."],
  ["short","Do nothing. On purpose."],
  ["short","You've earned an evening."],
  ["heart","You've always been harder on yourself than anybody else would be. This is me telling you to <em>&#8230;</em>"],
  ["heart","Rest isn't the reward for finishing. It's part of how you <em>&#8230;</em>"],
  ["heart","The people who last are the ones who know when to stop, and you have never been good at <em>&#8230;</em>"],
  ["heart","I'd rather you came home tired from living than from grinding. So go and <em>&#8230;</em>"]]],
 ["A good day for once","i-mirror",[
  ["funny","Go and get whatever it is you keep almost buying and then <em>&#8230;</em>"],
  ["funny","Stress does terrible things to a person. Counteract it with <em>&#8230;</em>"],
  ["funny","Whatever the thing is that makes you feel like a functioning human, go and <em>&#8230;</em>"],
  ["funny","You've done your own hair since you were about 11 and it has always looked better than <em>&#8230;</em>"],
  ["short","Because you deserve it."],
  ["short","Go feel like yourself."],
  ["short","For no reason at all."],
  ["short","Spend it on you."],
  ["heart","You have never needed any of this to be lovely. But it's nice to be looked after, so <em>&#8230;</em>"],
  ["heart","Take an afternoon that has nothing to do with anything you're supposed to be <em>&#8230;</em>"],
  ["heart","It's easy to stop looking after yourself when nobody's watching. Don't <em>&#8230;</em>"],
  ["heart","You carry yourself differently when you feel good, and I've watched that since <em>&#8230;</em>"]]],
 ["When the account says zero","i-alert",[
  ["funny","I have been exactly where you are. It isn't a character flaw, it's a Tuesday. Here's <em>&#8230;</em>"],
  ["funny","There's no joke on this page. It's the one you'll be glad <em>&#8230;</em>"],
  ["funny","Everybody is broke in college. Everybody. The ones who say otherwise are <em>&#8230;</em>"],
  ["funny","I hope you never need this page. Keep it <em>&#8230;</em>"],
  ["short","Call me. Really."],
  ["short","No questions asked."],
  ["short","For the hard week."],
  ["short","Don't wait to ask."],
  ["heart","If it's ever worse than this page can fix, you call me. There is no version of that call that <em>&#8230;</em>"],
  ["heart","You will never be in trouble for needing help. Not once, not ever. Just <em>&#8230;</em>"],
  ["heart","Money is the easiest problem you will ever bring me. Bring me <em>&#8230;</em>"],
  ["heart","I would far rather you asked 10 times too early than <em>&#8230;</em>"]]],
 ["Sunday night","i-cal",[
  ["funny","Sunday night has felt like this since the beginning of time. It isn't you, it's <em>&#8230;</em>"],
  ["funny","Whatever Monday has got, it's got nothing on you. Eat something sweet and <em>&#8230;</em>"],
  ["funny","Nobody in recorded history has enjoyed a Sunday evening, so don't take it as <em>&#8230;</em>"],
  ["funny","Put the phone down, eat something warm, and let Monday be <em>&#8230;</em>"],
  ["short","Monday's not that big."],
  ["short","It always looks worse tonight."],
  ["short","Early night. It helps."],
  ["short","It's only Sunday."],
  ["heart","You used to go quiet on Sunday evenings and I always noticed and never <em>&#8230;</em>"],
  ["heart","The week ahead always looks bigger on a Sunday than it does by Tuesday. It will <em>&#8230;</em>"],
  ["heart","I still get Sunday nights, at my age, and they never fully go away. What helps is <em>&#8230;</em>"],
  ["heart","Whatever's waiting on Monday, you'll handle it the way you always <em>&#8230;</em>"]]],
 ["Sick, and nobody's home","i-therm",[
  ["funny","There is no soup. I'm aware. This is soup money, which is the next <em>&#8230;</em>"],
  ["funny","Go to the health center. I know you don't want to. Go <em>&#8230;</em>"],
  ["funny","You are allowed to be completely pathetic about this. I would be. Be pathetic and <em>&#8230;</em>"],
  ["funny","Buy the expensive tissues and the ginger ale and whatever else you'd <em>&#8230;</em>"],
  ["short","Get the good tissues."],
  ["short","Text me how you're doing."],
  ["short","Health center. Today."],
  ["short","Sleep it off."],
  ["heart","This is the page I like least, because it's the one where I'd actually want to be there. Since I can't <em>&#8230;</em>"],
  ["heart","Being sick away from home is genuinely miserable and I'm sorry. Let somebody <em>&#8230;</em>"],
  ["heart","Call me even if there's nothing I can do. Especially <em>&#8230;</em>"],
  ["heart","If it gets bad you say so straight away. Don't do the thing where you <em>&#8230;</em>"]]],
 ["The book that cost too much","i-book",[
  ["funny","Two hundred dollars for a PDF is a crime and I'd like it noted that <em>&#8230;</em>"],
  ["funny","Check the library first. Then use this for the one they <em>&#8230;</em>"],
  ["funny","The textbook business is a racket and I want that on <em>&#8230;</em>"],
  ["funny","Ask a sophomore whether they still have theirs before you <em>&#8230;</em>"],
  ["short","Get the book."],
  ["short","Don't skip buying it."],
  ["short","Whatever you need. Get it."],
  ["short","Don't do without."],
  ["heart","Never go without something you need for school. That's what this is for, and <em>&#8230;</em>"],
  ["heart","I don't want cost to be the reason you're behind on anything, ever. Not while <em>&#8230;</em>"],
  ["heart","There is nothing I want less than you falling behind over something this <em>&#8230;</em>"],
  ["heart","We didn't send you there to go without the things that <em>&#8230;</em>"]]],
 ["A taste of home","i-plate",[
  ["funny","Imagine I cooked this. Imagine it was better than <em>&#8230;</em>"],
  ["funny","It won't be as good as mine. Enjoy it <em>&#8230;</em>"],
  ["funny","Nothing there will taste like Sunday, but some of it will come <em>&#8230;</em>"],
  ["funny","The recipe's on the card in the back pocket. Whether you ever cook it is <em>&#8230;</em>"],
  ["short","Eat like you're home."],
  ["short","Take somebody with you."],
  ["short","Something that tastes like us."],
  ["short","Bring a friend to it."],
  ["heart","Sunday dinner is still happening here every week. Your seat is <em>&#8230;</em>"],
  ["heart","Go somewhere with tablecloths, order what you'd order at home, and then call me and <em>&#8230;</em>"],
  ["heart","Food is how this family says the things it doesn't say out loud, which you probably <em>&#8230;</em>"],
  ["heart","The table's still set the same way here. It always <em>&#8230;</em>"]]],
 ["When you miss home","i-home",[
  ["short","We're right here."],
  ["short","Come home whenever."],
  ["short","Call. Any time."],
  ["short","Nothing's changed here."],
  ["heart","There's no card on this page and nothing to buy. This one is just <em>&#8230;</em>"],
  ["heart","Missing home means you had one worth missing. That's the whole thing, and I <em>&#8230;</em>"],
  ["heart","I miss you too. Every day, and especially on <em>&#8230;</em>"],
  ["heart","Your room is exactly how you left it. It'll be there at Thanksgiving and it'll be there <em>&#8230;</em>"],
  ["heart","Homesick is just love with nowhere to put it for a minute. It <em>&#8230;</em>"],
  ["heart","You can come home for a weekend any time you like and you never have to explain <em>&#8230;</em>"],
  ["heart","I told myself I wouldn't write anything on this page that would make you cry, and then I <em>&#8230;</em>"],
  ["heart","Wherever you end up living, this stays the place you can turn up to without <em>&#8230;</em>"]]]
];
const LABEL={funny:"Funny",short:"Short",heart:"Heart"};
const store=(k,v)=>{try{return v===undefined?localStorage.getItem(k):localStorage.setItem(k,v)}catch(e){return null}};
const pick=(a,seed)=>a[Math.abs(seed)%a.length];
const fill=(s)=>{
  const n=(P.name||'').trim(), t=(P.thing||'').trim()||(P.did==='sport'?'practice':'your thing');
  let out=s.replace(/\{thing\}/g,t);
  if(n) out=out.replace(/\{name\}/g,n);
  else out=out.replace(/,\s*\{name\},/g,',').replace(/\{name\},\s*/g,'').replace(/\s*\{name\}/g,'');
  return out;
};
const HOOKS=[
["An 8 a.m. class is a cruel thing to do to a person.","Nobody in this family has ever been a morning person.","The hardest part of any 8 a.m. is the 12 feet between the bed and the door."],
["The dining hall is going to lose more often than it wins.","There is a decent meal in that town somewhere.","You should eat something hot at least once this week."],
["Nothing sensible has ever been decided at 2 a.m.","The best hours of college happen after midnight.","I'm not asking what you're doing awake."],
["There is no fairy who restocks the toilet paper.","Running out of everything at once is a rite of passage.","Nobody warns you what paper towels cost."],
["Studying is 10 percent studying and 90 percent snacks.","Nobody has ever done their best work at 4 a.m.","This week is going to feel bigger than it actually is."],
["A full closet and nothing to wear is a permanent human condition.","Half of what I packed you will never touch.","There is an outfit out there that makes you feel unstoppable."],
["Walking builds character. So does not walking, at midnight, in the rain.","The ride exists for a reason.","There is no amount I wouldn't spend on you getting back in one piece."],
["That charger has been held together by hope since March.","A dead phone is only ever a problem for whoever is trying to reach you.","Buy 2. You will lose one inside a month."],
["Cold water, and keep the red thing away from the white things.","The day you run out of clean everything is coming for you.","Clean sheets at the end of a long week do more than they should."],
["You are excused from being impressive for one evening.","Rest isn't the reward for finishing.","Cancel something. Anything."],
["Go and get whatever it is you keep almost buying.","It's easy to stop looking after yourself when nobody's watching.","You carry yourself differently when you feel good."],
["Everybody is broke in college. Everybody.","This is the page I hope you never need.","Money is the easiest problem you will ever bring me."],
["Sunday night has felt like this since the beginning of time.","The week ahead always looks bigger on a Sunday than it does by Tuesday.","I still get Sunday nights, at my age."],
["Being sick away from home is genuinely miserable and I'm sorry.","There is no soup. I'm aware.","You are allowed to be completely pathetic about this."],
["Two hundred dollars for a PDF is a crime.","Never go without something you need for school.","Check the library first."],
["Nothing there will taste like Sunday.","Sunday dinner is still happening here every week.","Food is how this family says the things it doesn't say out loud."],
["Missing home means you had one worth missing.","Your room is exactly how you left it.","There is no card on this page and nothing to buy."]];

const GLUE={
 nature:{
  quiet:"You don't say much when things are hard, {name}, which is exactly why I'm putting it in writing.",
  funny:"You'd make a joke about this, so I'll let you have that one.",
  worrier:"I know you'll have thought about this more than it deserves already.",
  tough:"You'll tell me you're fine. You usually are. Still.",
  golden:"You'll probably end up sorting this out for somebody else on your floor too.",
  perfect:"You're going to want to get this exactly right, and you don't have to."},
 did:{
  sport:"You've been getting yourself out the door for {thing} since you were small, so I'm not worried.",
  stage:"You've stood up in front of a room full of people and performed. This is nothing.",
  art:"You've always been able to make something out of nothing, and that's most of what this year is.",
  game:"You've kept up with people you've never met in person for years, so keeping up with us should be easy.",
  work:"You've been showing up for a shift since you were 16, and that's a bigger deal than anybody told you.",
  none:"You've never needed to be the busiest person in the room and I've always liked that about you."},
 who:{
  gran:"I'm a good way down the pecking order these days, and that is exactly how it should be.",
  gramp:"I'm not going to pretend I know how any of it works now. Some things haven't changed.",
  dad:"You know I'm better at fixing things than saying them."},
 far:{
  flight:"There's a plane between us, which I think about more often than I let on.",
  mid:"You're a few hours away, which is close enough to come home and far enough to feel it.",
  near:"You're not far. That doesn't mean the house isn't quieter."}};

const HANDOFF={
 joke:["Anyway. The actual thing I wanted to say is <em>&#8230;</em>","Don't tell anyone I got sentimental. Here's the real bit: <em>&#8230;</em>","That's enough out of me. What I mean is <em>&#8230;</em>"],
 plain:["What I want you to know is <em>&#8230;</em>","So here's the real thing: <em>&#8230;</em>","The part that matters is <em>&#8230;</em>"],
 soft:["And the thing I keep meaning to say out loud is <em>&#8230;</em>","Mostly I just want you to know <em>&#8230;</em>","If you read one line on this page, read this one: <em>&#8230;</em>"]};

/* the hard pages need different glue &#8212; resilience reads wrong when they're sick or broke */
const SOFT_MOMENTS=new Set([11,12,13,16]);
const GLUE_SOFT={
 nature:{
  quiet:"You don't say much when it's bad, {name}, so I'm saying it first.",
  funny:"You'd make a joke to get out of this one, and normally I'd let you.",
  worrier:"I know your head is already 3 steps ahead. Let it rest for a minute.",
  tough:"You'll say it's fine. You don't have to, not on this page.",
  golden:"You look after everybody else. Somebody should be looking after you.",
  perfect:"None of this is a test and there's no way to get it wrong."},
 did:{
  sport:"You've played hurt before and I never liked it then either.",
  stage:"You've had nights it didn't go right and gone back the next day anyway.",
  art:"You've always been able to sit with something difficult until it made sense.",
  game:"There is somebody awake right now who would pick up. Let them.",
  work:"You've pushed through a shift feeling worse than this. You don't have to today.",
  none:"You don't have to be doing anything for me to be glad you're mine."},
 who:{
  gran:"I'm a long way down the pecking order and I'd still drop everything.",
  gramp:"I'm not much use at this from here, and I'd still come.",
  dad:"I'd fix it if it were the kind of thing I could fix."},
 far:{
  flight:"There's a plane between us and I would get on it.",
  mid:"You're a few hours away, which is close enough that I'd just come.",
  near:"You're close enough that I'd be there within the hour if you asked."}};

const RANK={funny:["funny","short","heart"],golden:["funny","heart","short"],
 tough:["short","funny","heart"],quiet:["heart","short","funny"],
 worrier:["heart","short","funny"],perfect:["heart","short","funny"]};

const READS={
 quiet:["They won't tell you when it's bad.","Put your most direct lines on the sick page and the one about the account hitting zero. Those are the two they'll never bring up first."],
 funny:["Lead with funny and let exactly one page be serious.","The serious one hits harder for the contrast. Most people do it the other way round and wonder why it reads flat."],
 worrier:["Reassurance beats encouragement.","Say what you're <b>not</b> worried about, and why. That does more than telling them they'll be great."],
 tough:["Short lines land, long ones get skimmed.","Don't over-explain. Say it in six words and let it sit there."],
 golden:["They will show this book to their roommate.","Write at least 3 pages you'd be happy for a stranger to read, and keep the private one private."],
 perfect:["Take the pressure off, page by page.","Every line that says 'whatever happens, it doesn't change anything' is written for this kid."]};

/* ---------- keyword bank for the free-text answer ---------- */
const KEYS=[
 {re:/\b(soccer|football|basketball|baseball|softball|track|cross ?country|swim team|swimming|tennis|volleyball|wrestling|hockey|lacrosse|golf|rowing|crew|gymnastics|cheerleading|cheer|dance)\b/i,
  g:"You've been getting yourself out the door for {m} since you were small.",
  s:"You've played hurt before and I never liked it then either."},
 {re:/\b(guitar|piano|violin|drums|band|choir|orchestra|singing|theater|theatre|drama|musicals?|acting)\b/i,
  g:"You've stood up in front of a room full of people and done it. This is nothing next to that.",
  s:"You've had nights it didn't go right and gone back the next day anyway."},
 {re:/\b(art|drawing|draws|painting|paints|photography|photos|film|design|ceramics|pottery|writing)\b/i,
  g:"You've always been able to make something out of nothing, and that's most of what this year is.",
  s:"You've always been able to sit with something difficult until it made sense."},
 {re:/\b(gaming|gamer|valorant|minecraft|fortnite|twitch|discord|xbox|playstation)\b/i,
  g:"You've kept up with people you've never met in person for years, so keeping up with us should be easy.",
  s:"There is somebody awake right now who would pick up. Let them."},
 {re:/\b(job|works|working|shifts?|saved up|savings|paycheck)\b/i,
  g:"You've been showing up for a shift since you were 16, and that's a bigger deal than anybody told you.",
  s:"You've pushed through a shift feeling worse than this. You don't have to today."},
 {re:/\b(dog|puppy|cat|kitten|horse|pet)\b/i,
  g:"{M} still waits by the door around the time you used to come in.",
  s:"{M} has been sleeping on your bed since you left, which I have been allowing."},
 {re:/\b(little brother|little sister|brother|sister|sibling|twin)\b/i,
  g:"Your {m} won't say it out loud, so I will: they miss you.",
  s:"Your {m} asked about you again this week."},
 {re:/\b(nursing|nurse|engineering|engineer|pre-?med|medicine|law school|law|business|computer science|comp sci|biology|chemistry|physics|psychology|architecture|teaching|education)\b/i,
  g:"You picked something hard on purpose, which is very you.",
  s:"Nobody gets through {m} without a week like this one. It isn't a sign of anything."},
 {re:/\b(anxiety|anxious|adhd|panic|therapy|therapist|depression|overthinks?|overthinking)\b/i,
  g:"You've done the work on this and it shows, even on the days it doesn't feel like it.",
  s:"You know what this is and you know it passes. That doesn't make it easier tonight."},
 {re:/\b(first generation|first-gen|first in the family|first in our family|first to go)\b/i,
  g:"You're the first one of us to do this and nobody handed you a map.",
  s:"Nobody in this family has done this before, so there is no version of it you're doing wrong."},
 {re:/\b(homesick|homebody|never been away|first time away|close to home)\b/i,
  g:"You've never been one for being away, and you went anyway. That's the part people miss.",
  s:"You've never been one for being away. Missing it isn't a step backwards."},
 {re:/\b(cooks|cooking|bakes|baking|chef)\b/i,
  g:"You'll be the one on that floor who can actually cook, which will make you popular quickly.",
  s:"Make yourself something proper. You know how, and it helps more than it should."},
 {re:/\b(car|truck|jeep|driving|drives|license|licence)\b/i,
  g:"Keep an eye on that {m} of yours.",
  s:"If the {m} is the problem, that's a phone call, not a crisis."},
 {re:/\b(break ?up|broke up|girlfriend|boyfriend|dumped)\b/i, softOnly:true,
  s:"Whatever happened before you left doesn't get to follow you there."},
 {re:/\b(passed away|passed|died|death|funeral|we lost)\b/i, softOnly:true,
  s:"They would have been so pleased about this. I think about that more than I say."}
];
function scanExtra(txt){
  const t=txt||'', out=[];
  /* if they named the pet or the sibling, use the name instead of the noun */
  const named=t.match(/\b(dog|puppy|cat|kitten|horse|brother|sister)\s+(?:called|named)\s+([A-Z][a-z]+)/);
  KEYS.forEach(k=>{const m=t.match(k.re); if(!m) return;
    let word=m[0].toLowerCase();
    if(named&&named[1].toLowerCase()===word) word=named[2];
    out.push({g:k.g,s:k.s,m:word,softOnly:!!k.softOnly})});
  return out;
}

/* ---------- quiz definition ---------- */
const QS=[
 {k:'name',type:'text',q:'What do you call them?',ph:'Jack',
  hint:'Whatever you actually say out loud, not what is on the birth certificate.'},
 {k:'who',type:'opt',q:'Who is writing this one?',
  opts:[['mom','Their mom'],['dad','Their dad'],['gran','Their grandmother'],
        ['gramp','Their grandfather'],['other','Somebody else']]},
 {k:'nature',type:'opt',q:'What are they like?',
  hint:'Pick the one you would say first if a stranger asked.',
  opts:[['quiet','The quiet one'],['funny','The funny one'],['worrier','The worrier'],
        ['tough','Acts like nothing bothers them'],['golden','Everybody&rsquo;s friend'],
        ['perfect','The perfectionist']]},
 {k:'did',type:'opt',q:'What did they spend high school doing?',
  opts:[['sport','Played a sport'],['stage','Music, band or theater'],['art','Art or making things'],
        ['game','Mostly online with their friends'],['work','Had a job'],['none','Not much, honestly']]},
 {k:'thing',type:'text',q:'Which one?',ph:'soccer',hint:'One word is plenty.',
  when:p=>['sport','stage','art'].includes(p.did)},
 {k:'tone',type:'opt',q:'How do the two of you talk?',
  opts:[['joke','We joke around'],['plain','Plain and straight'],['soft','Softer than that']]},
 {k:'far',type:'opt',q:'How far away are they?',
  opts:[['near','Under an hour'],['mid','A few hours'],['flight','A flight']]},
 {k:'extra',type:'area',q:'Anything else I should know about them?',
  ph:'She has never been away from home. Plays soccer. Her grandpa died in March and she was closest to him.',
  hint:'Write it the way you would say it to a friend. I will pull out what I can use and keep the rest in front of you while you write.'}
];

/* ---------- kids ---------- */
let KIDS=[],ACTIVE=0;
try{KIDS=JSON.parse(store('vault-kids')||'null')||[]}catch(e){KIDS=[]}
if(!KIDS.length){let old={};try{old=JSON.parse(store('vault-profile')||'{}')}catch(e){}
  KIDS=[Object.keys(old).length?old:{}]}
ACTIVE=Math.min(+(store('vault-active')||0),KIDS.length-1);
let P=KIDS[ACTIVE];
function saveKids(){store('vault-kids',JSON.stringify(KIDS));store('vault-active',ACTIVE)}

const activeQs=()=>QS.filter(q=>!q.when||q.when(P));
const answered=()=>activeQs().filter(q=>q.k!=='extra'&&q.k!=='thing').every(q=>P[q.k]);
let STEP=0,EDITING=false;

function kidName(i){return (KIDS[i].name||'').trim()||('Kid '+(i+1))}
function drawTabs(){
  const t=document.getElementById('kidtabs');
  if(KIDS.length<2&&!answered()){t.innerHTML='';return}
  t.innerHTML=KIDS.map((k,i)=>'<button class="kidtab" data-k="'+i+'" aria-pressed="'+(i===ACTIVE)+'">'+
    kidName(i)+(KIDS.length>1?'<span class="x" data-del="'+i+'">&times;</span>':'')+'</button>').join('')+
    (KIDS.length<2?'<button class="kidtab add" data-add="1">+ Add a second</button>':'');
}
document.getElementById('kidtabs').addEventListener('click',e=>{
  const del=e.target.closest('[data-del]');
  if(del){KIDS.splice(+del.dataset.del,1);ACTIVE=0;P=KIDS[0];saveKids();STEP=0;EDITING=false;boot();return}
  if(e.target.closest('[data-add]')){KIDS.push({});ACTIVE=KIDS.length-1;P=KIDS[ACTIVE];saveKids();
    STEP=0;EDITING=true;boot();document.getElementById('about').scrollIntoView({behavior:'smooth'});return}
  const t=e.target.closest('[data-k]');
  if(t){ACTIVE=+t.dataset.k;P=KIDS[ACTIVE];saveKids();STEP=0;EDITING=false;boot()}
});

function drawQuiz(){
  const stage=document.getElementById('qstage'),qs=activeQs(),top=document.querySelector('.qtop');
  if(answered()&&!EDITING){
    top.hidden=true;
    stage.innerHTML='<div class="qdone"><div class="tick">&#10003;</div><h3>All set'+
      (P.name?', that is '+P.name:'')+'</h3><p>Everything below is now sorted for them.</p>'+
      '<div class="qrow" style="justify-content:center"><button class="btn" data-go="write">See their lines</button>'+
      '<button class="btn ghost" data-edit="1">Change my answers</button></div></div>';
    return;
  }
  top.hidden=false;
  STEP=Math.max(0,Math.min(STEP,qs.length-1));
  const q=qs[STEP];
  document.getElementById('qcount').textContent=(STEP+1)+' of '+qs.length;
  document.getElementById('qdots').innerHTML=qs.map((_,i)=>
    '<span class="qdot '+(i<STEP?'on':i===STEP?'now':'')+'"></span>').join('');
  document.getElementById('qback').hidden=STEP===0;
  let inner='<h3 class="qq">'+q.q+'</h3>'+(q.hint?'<p class="qhint">'+q.hint+'</p>':'');
  if(q.type==='opt'){
    inner+='<div class="qopts">'+q.opts.map(o=>'<button class="qopt" data-v="'+o[0]+
      '" aria-pressed="'+(P[q.k]===o[0])+'">'+o[1]+'</button>').join('')+'</div>';
  }else if(q.type==='text'){
    inner+='<input class="fld" id="qin" placeholder="'+q.ph+'" autocomplete="off" value="'+
      (P[q.k]||'').replace(/"/g,'&quot;')+'"><div class="qrow"><button class="btn" data-next="1">Next</button>'+
      '<button class="qskip" data-skip="1">Skip</button></div>';
  }else{
    inner+='<textarea class="fld" id="qin" rows="4" placeholder="'+q.ph+'">'+(P[q.k]||'')+
      '</textarea><div class="qrow"><button class="btn" data-next="1">Done</button>'+
      '<button class="qskip" data-skip="1">Nothing comes to mind</button></div>';
  }
  stage.innerHTML=inner;
  const inp=document.getElementById('qin');
  if(inp&&q.type==='text') inp.addEventListener('keydown',e=>{
    if(e.key==='Enter'){e.preventDefault();advance()}});
}
function advance(){
  const q=activeQs()[STEP],inp=document.getElementById('qin');
  if(inp) P[q.k]=inp.value.trim();
  saveKids();
  if(STEP>=activeQs().length-1){EDITING=false;boot();
    document.getElementById('readback').scrollIntoView({behavior:'smooth',block:'center'});return}
  STEP++;boot();
}
document.getElementById('quiz').addEventListener('click',e=>{
  const o=e.target.closest('.qopt');
  if(o){P[activeQs()[STEP].k]=o.dataset.v;saveKids();o.setAttribute('aria-pressed','true');
    setTimeout(advance,140);return}
  if(e.target.closest('[data-next]')){advance();return}
  if(e.target.closest('[data-skip]')){P[activeQs()[STEP].k]='';saveKids();advance();return}
  if(e.target.closest('[data-edit]')){EDITING=true;STEP=0;boot();return}
  if(e.target.closest('[data-go]')) document.getElementById('write').scrollIntoView({behavior:'smooth'});
});
document.getElementById('qback').addEventListener('click',()=>{if(STEP>0){STEP--;boot()}});
function boot(){drawTabs();drawQuiz();readback();render()}

function readback(){
  const box=document.getElementById('readback');
  if(!answered()&&!P.nature){box.innerHTML='<p class="empty">Answer a few of these and I will tell you what actually lands for a kid like that, then reorder every line below to match.</p>';return}
  const n=(P.name||'').trim(),bits=[];
  if(P.nature&&READS[P.nature]) bits.push(READS[P.nature]);
  if(P.tone==='joke') bits.push(["Keep the register light all the way through.","If more than 3 pages go soft it reads like something is wrong. Save it for the last page."]);
  if(P.tone==='soft') bits.push(["You can be direct here in a way you might not be out loud.","Paper carries things a conversation will not. Use that."]);
  if(P.far==='flight') bits.push(["Distance is the thing to write about.","Spend your best line on the getting-there page or the miss-home page. Those are the two that get reread on a plane."]);
  const hits=scanExtra(P.extra);
  if(hits.length) bits.push(["I found "+hits.length+" thing"+(hits.length>1?'s':'')+" in your note I can use.","They are woven into the drafts below, and the whole note stays pinned above the lines so you do not lose it."]);
  else if((P.extra||'').trim()) bits.push(["Your note is pinned above the lines.","Nothing in it matched a pattern I can weave in automatically, but it is the best prompt you have. Keep looking at it while you write."]);
  else if(P.did&&P.did!=='none') bits.push(["Use what they already did for 4 years.","One line that references it proves you were watching, and it beats any general compliment."]);
  box.innerHTML='<h3>'+(n?('Writing for '+n):'What tends to land')+'</h3><ul>'+
    bits.map(b=>'<li><b>'+b[0]+'</b> '+b[1]+'</li>').join('')+'</ul>';
}

const host=document.getElementById('moments');
function render(){
  const openSet=new Set([...host.querySelectorAll('details[open]')].map(d=>d.dataset.i));
  const order=RANK[P.nature]||(P.tone==='joke'?RANK.funny:null);
  const n=(P.name||'').trim(),hits=scanExtra(P.extra),rem=document.getElementById('remind');
  if((P.extra||'').trim()){
    rem.hidden=false;
    rem.innerHTML='<span class="eyebrow">Work this in</span><p>'+P.extra.replace(/</g,'&lt;')+'</p>'+
      (hits.length?'<p class="hit">'+hits.length+' of these are in the drafts below.</p>':'');
  }else rem.hidden=true;
  host.innerHTML='';
  MOMENTS.forEach((m,i)=>{
    const title=m[0],icon=m[1],lines=m[2];
    let ls=lines.map((l,ix)=>({t:l[0],x:l[1],ix}));
    if(order) ls.sort((a,b)=>(order.indexOf(a.t)-order.indexOf(b.t))||(a.ix-b.ix));
    const d=document.createElement('details');
    d.className='moment';d.dataset.i=i;
    if(openSet.has(String(i))) d.open=true;
    d.innerHTML='<summary class="mhead"><svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><use href="#'+icon+'"/></svg>'+
      '<span class="mtitle">'+title+'</span><span class="mn">'+(i+1)+'/17</span>'+
      '<svg class="caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><use href="#i-caret"/></svg></summary>'+
      '<div class="mbody">'+
      (i===16?'<p class="note">This is the page people cry at. Nothing funny goes here, and it works better with no card in it at all.</p>':'')+
      '<ul class="lines">'+ls.map((l,pos)=>'<li data-tone="'+l.t+'"><button class="line">'+
        '<span class="tag '+l.t+'">'+LABEL[l.t]+'</span><span class="txt">'+l.x+
        (order&&pos<2?'<span class="pick">'+(n?'For '+n:'Picked')+'</span>':'')+'</span></button></li>').join('')+
      '</ul><div class="draft" data-m="'+i+'"><div class="dhead"><span class="eyebrow">Write one from scratch</span>'+
      '<button class="btn" data-draft="'+i+'">Draft 3 lines</button></div>'+
      '<div class="dbox"><p class="dempty">Built from what you told me about '+(n||'them')+'. Tap a draft to copy it.</p></div></div>'+
      '<label class="done"><input type="checkbox" data-page="'+i+'"> I have written this page</label></div>';
    host.appendChild(d);
  });
  document.querySelectorAll('[data-page]').forEach(b=>{
    b.checked=store('vault-k'+ACTIVE+'p'+b.dataset.page)==='1';
    b.addEventListener('change',()=>{store('vault-k'+ACTIVE+'p'+b.dataset.page,b.checked?'1':'0');paint()});
  });
  applyFilter();paint();
}

let spin=0;
function drafts(i){
  const soft=SOFT_MOMENTS.has(i),G=soft?GLUE_SOFT:GLUE,pools=[];
  if(P.nature&&G.nature[P.nature]) pools.push(G.nature[P.nature]);
  if(P.did&&G.did[P.did]) pools.push(G.did[P.did]);
  if(P.who&&G.who[P.who]) pools.push(G.who[P.who]);
  if(P.far&&G.far[P.far]) pools.push(G.far[P.far]);
  scanExtra(P.extra).forEach(h=>{
    const line=soft?h.s:(h.softOnly?null:h.g);
    if(line){
      const named=/^[A-Z]/.test(h.m);
      pools.unshift(line.replace(/\{M\}/g, named?h.m:('The '+h.m)).replace(/\{m\}/g,h.m));
    }
  });
  const hands=HANDOFF[(soft&&P.tone==='joke')?'plain':(P.tone||'plain')];
  const out=[];
  for(let k=0;k<3;k++){
    const s=spin+k;
    out.push([pick(HOOKS[i],s+i*3), pools.length?fill(pick(pools,s+i)):'', pick(hands,s+i*2)]
      .filter(Boolean).join(' '));
  }
  spin+=3;return out;
}
host.addEventListener('click',e=>{
  const btn=e.target.closest('[data-draft]');
  if(btn){const i=+btn.dataset.draft,box=btn.closest('.draft').querySelector('.dbox');
    box.innerHTML=drafts(i).map(t=>'<p class="dout">'+t+'</p>').join('');
    btn.textContent='Try 3 more';return}
  const d=e.target.closest('.dout');if(d){copy(d,d.textContent);return}
  const b=e.target.closest('.line');if(b){copy(b,b.querySelector('.txt').textContent)}
});
function copy(node,text){
  const t=text.replace(/(For .*|Picked)$/,'').replace(/&#8230;\s*$/,'').trim();
  navigator.clipboard&&navigator.clipboard.writeText(t).catch(()=>{});
  document.querySelectorAll('.copied').forEach(x=>x.classList.remove('copied'));
  node.classList.add('copied');setTimeout(()=>node.classList.remove('copied'),1600);
}

let FILTER='all';
document.querySelectorAll('.chip').forEach(c=>c.addEventListener('click',()=>{
  FILTER=c.dataset.f;
  document.querySelectorAll('.chip').forEach(o=>o.setAttribute('aria-pressed',String(o===c)));
  applyFilter();
}));
function applyFilter(){document.querySelectorAll('.lines li').forEach(li=>{
  li.hidden=!(FILTER==='all'||li.dataset.tone===FILTER)})}
const bar=document.getElementById('pbar'),num=document.getElementById('pdone'),note=document.getElementById('pnote');
function paint(){
  const n=[...document.querySelectorAll('[data-page]')].filter(b=>b.checked).length;
  num.textContent=n;bar.style.width=(n/17*100)+'%';
  note.textContent=n===0?'Start anywhere':n<17?(17-n)+' to go':'All done. Go hand it over.';
}
boot();
